import { useEffect } from 'react';
import { useBrand } from '../hooks/useBrand';

/**
 * FaviconManager component that dynamically updates the page favicon,
 * title, and meta description based on the current brand
 * This component renders nothing (returns null)
 */
export function FaviconManager() {
  const brand = useBrand();

  useEffect(() => {
    // Update favicon
    let faviconLink = document.querySelector("link[rel~='icon']");

    if (!faviconLink) {
      // Create favicon link if it doesn't exist
      faviconLink = document.createElement('link');
      faviconLink.rel = 'icon';
      document.head.appendChild(faviconLink);
    }

    faviconLink.href = brand.favicon;

    // Update document title
    document.title = brand.meta.title;

    // Update meta description
    let metaDescription = document.querySelector("meta[name='description']");

    if (!metaDescription) {
      // Create meta description if it doesn't exist
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }

    metaDescription.content = brand.meta.description;
  }, [brand]);

  // This component doesn't render anything
  return null;
}
